export class RouteViewKeys {
    public static readonly SEARCH = '';
    public static readonly DETAIL = 'course-detail';
    public static readonly LOGIN = 'course-login';
    public static readonly SHOPPING_CART = 'shopping-cart';
    public static readonly SUMMARY = 'summary';
    public static readonly SUMMARY_CO_BRANDING = 'summary-co-branding';
    public static readonly CLASSIFICATION = 'course-classification'; // inactive
    public static readonly CONFIRMATION = 'booking-confirmation';
    public static readonly CONFIRMATION_CO_BRANDING = 'booking-confirmation-co-branding';
    public static readonly HCO_CODE = 'hco-code'; // inactive
    public static readonly VERIFICATION = 'verification';
    public static readonly INTAKE_REGISTRATION = 'intake-registration';
    public static readonly DAAD_REGISTRATION = 'daad-registration';
    public static readonly DFH_REGISTRATION = 'dfh-registration';
    public static readonly BOOK_NEXT_COURSE = 'next-intake-course';
    public static readonly PENDING = 'pending';
}
